<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <Toast />
        <div class="grid p-fluid mt-3" style="margin-top: 2%">
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText v-model="advertize_name"> </InputText>
              <label>Advertise Name</label>
            </span>
          </div>
          <!-- <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Calendar
                    v-model="advertize_from_date"
                    dateFormat="dd-mm-yy"
                    :showIcon="true"
                    :showTime="false"
                    hourFormat="12"
                  />
                  <label>From Date</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Calendar
                    v-model="advertize_to_date"
                    dateFormat="dd-mm-yy"
                    :showIcon="true"
                    :showTime="false"
                    hourFormat="12"
                  />
                  <label>To Date</label>
                </span>
              </div> -->
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="advertize_status"
                :options="dropdownItems"
                :value="dropdownItems.value"
                optionLabel="name"
              ></Dropdown>
              <label>Status</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown
                id="type"
                v-model="advertize_type"
                :options="typedropdownItems"
                :value="typedropdownItems.value"
                optionLabel="name"
              ></Dropdown>
              <label>Type</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <Button
              icon="pi pi-search"
              v-tooltip.bottom="'Search'"
              @click="search(1)"
            />
          </div>
        </div>
        <!-- </template> -->
        <!-- <template v-slot:end> -->
        <!-- &nbsp;
              <json-excel :data="product">
                <Button
                  icon="pi pi-upload"
                  v-tooltip.bottom="'export'"
                  @click="exportCSV"
                />
              </json-excel> -->
        <!-- {{products[0]}} -->
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($advertize)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5 class="m-0"><b> Advertise Master</b></h5>
              <!-- Total Records:{{totalRecords}} -->
              <div>
                <Button
                  icon="pi pi-refresh"
                  @click="search(2)"
                  v-tooltip.bottom="'Refresh'"
                />&nbsp;
                <Button
                  icon="pi pi-plus"
                  v-tooltip.bottom="'Add'"
                  @click="openNew"
                />&nbsp;
                <Button
                  icon="pi pi-upload"
                  v-tooltip.bottom="'export'"
                  @click="exportCSV"
                />
              </div>
            </div>
            <div style="text-align: right; font-weight: bold">
              <span>Total advertise:</span>{{ totalRecords }}
            </div>
          </template>
          <Column
            header="Status"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge :value="data.status" severity="success"></badge
              ></span>
              <span
                v-else-if="
                  data.status == 'InActive' || data.status == 'In Active'
                "
                ><badge :value="data.status" severity="warning"></badge
              ></span>
              <span
                v-else-if="data.status == 'Delete' || data.status == 'Deleted'"
                ><badge :value="data.status" severity="danger"></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column
            header="advertise Name"
            :field="columns[1]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.name }}
            </template>
          </Column>
          <Column
            header="Description"
            :field="columns[3]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.description }}
            </template>
          </Column>
          <Column
            header="Short Description"
            :field="columns[2]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.short_description }}
            </template>
          </Column>
          <Column
            header="Type"
            :field="columns[4]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.type }}
            </template>
          </Column>
          <!-- <Column
            header="status"
            :field="columns[5]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.status }}
            </template>
          </Column> -->
          <Column header="url" :field="columns[6]" style="min-width: 5rem">
            <template #body="{ data }">
                <div v-if="data.type === 'video'" class="video-cell">
                  <Button
                        icon="pi pi-youtube"
                        severity="danger" rounded outlined
                        @click="view_video(data.url)"
                        
                    />
                    <!-- <iframe width="150" height="100" :src="data.url"></iframe> -->
                </div>
                <div v-else-if="data.type === 'image'">
                    <!-- <img preview :src="data.url" :alt="data.url" class="shadow-2" width="50"  >   -->
                    <Image :src="data.url" alt="Image" width="50" preview />              
                </div>
                <div v-else>
                    <span>-</span>
                </div>
                
        
            </template>
          </Column>
          <!-- <Column
              header="From Date"
              :field="columns[4]"
              style="min-width: 5rem"
            >
              <template #body="{ data }">
                {{ dateFormatYMD(data.from_date) }}
              </template>
            </Column> -->
          <!-- <Column header="To Date" :field="columns[4]" style="min-width: 5rem">
              <template #body="{ data }">
                {{ dateFormatYMD(data.to_date) }}
              </template>
            </Column>
            <Column header="State" :field="columns[4]" style="min-width: 5rem">
              <template #body="{ data }">
                {{ data.state }}
              </template>
            </Column>
            <Column header="City" :field="columns[4]" style="min-width: 5rem">
              <template #body="{ data }">
                {{ data.city }}
              </template>
            </Column>
            <Column header="Pincode" :field="columns[4]" style="min-width: 5rem">
              <template #body="{ data }">
                {{ data.pincode }}
              </template>
            </Column> -->
          <Column header="Action" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-help mr-2"
                v-tooltip.bottom="'Edit'"
                @click="editProduct(slotProps.data)"
              />
              <Button
                v-if="slotProps.data.status != 'Deleted'"
                icon="pi pi-trash"
                v-tooltip.bottom="'Delete'"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>
        <Dialog
          header="advertisement"
          v-model:visible="productDialog"
          :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '70vw' }"
          :modal="true"
        >
          <div class="col-12">
            <div class="card">
              <div class="p-fluid formgrid grid">
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <InputText
                      id="name"
                      type="text"
                      v-model.trim="product.name"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.name }"
                    />
                    <label for="name">advertise Name</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Dropdown
                      id="status"
                      v-model="selectstatus"
                      :options="dropdownItems"
                      :value="dropdownItems.value"
                      optionLabel="name"
                      :class="{ 'p-invalid': submitted && !selectstatus }"
                      required="true"
                    ></Dropdown>
                    <label for="status">Advertise Status</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Dropdown
                      id="status"
                      v-model="selecttype"
                      :options="typedropdownItems"
                      :value="typedropdownItems.value"
                      optionLabel="name"
                      :class="{ 'p-invalid': submitted && !selecttype }"
                      required="true"
                    ></Dropdown>
                    <label for="status">Advertise Status</label>
                  </span>
                </div>
                <div class="field col-12 md:col-12" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Textarea
                      id="url"
                      type="text"
                      rows="1"
                      v-model.trim="product.url"
                      required="true"
                      autofocus
                      :class="{
                        'p-invalid': submitted && !product.url,
                      }"
                    />
                    <label for="url">URL</label>
                  </span>
                </div>
                <div class="field col-12 md:col-12" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Textarea
                      id="short_description"
                      type="text"
                      rows="2"
                      v-model.trim="product.short_description"
                      required="true"
                      autofocus
                      :class="{
                        'p-invalid': submitted && !product.short_description,
                      }"
                    />
                    <label for="short_description">Short Description</label>
                  </span>
                </div>
                <div class="field col-12 md:col-12" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Textarea
                      id="description"
                      type="text"
                      rows="4"
                      v-model.trim="product.description"
                      required="true"
                      autofocus
                      :class="{
                        'p-invalid': submitted && !product.description,
                      }"
                    />
                    <label for="description">Description</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <template #footer>
            <Button
              v-if="product._id"
              label="Update"
              @click="add_update_advertize"
              icon="pi pi-check"
              class="p-button-warning"
            />
            <Button
              v-else
              label="add"
              @click="add_update_advertize"
              icon="pi pi-check"
              class="p-button-warning"
            />
          </template>
        </Dialog>
        <!-- 
  -----------------------------------------------------------------------------------------------------------   -->
        <Dialog
          v-model:visible="deleteProductDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete advertise
              <b>{{ product.name }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteadvertize"
            />
          </template>
        </Dialog>
        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected products?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
//import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";
//import FormNewsMaster from "@/components/FormNewsMaster";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";
export default {
  data() {
    return {
      place_details: "",
      end_place_details: "",
      searchme: "",
      name: "",
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      icon_dropdown: [],
      advertize_name: "",
      // advertize_from_date: "",
      // advertize_to_date: "",
      advertize_status: null,
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      advertize_type: null,
      typedropdownItems: [
        { name: "video", value: "video" },
        { name: "image", value: "image" },
      ],
      parent_dropdownItems: [],
      selectstatus: { name: "", value: "" },
      selecttype: { name: "", value: "" },
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      icons: null,
      totalRecords: 0,
      id: "",
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
      "advertises",
      "/advertize_master"
    );
    //let Breadcrum_data = this.BreadcrumbService.menumaster();
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    async view_video(url)
    {
        if (url && url!='') 
        {
            window.open(url, "_blank");
        }
    },
    async search(count) {
      if (count == 2) {
        this.advertize_name = "";
        //   this.advertize_from_date = "";
        //   this.advertize_to_date = "";
        this.advertize_status = null;
        this.advertize_type = null;
      }
      await this.get_list();
      await this.get_count();
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      this.selectstatus = { name: "", value: "" };
      this.selecttype = { name: "", value: "" };
      if (this.product.status) {
        this.selectstatus.value = this.product.status;
        this.selectstatus.name = this.product.status;
      }
      if (this.product.type) {
        this.selecttype.value = this.product.type;
        this.selecttype.name = this.product.type;
      }
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.pradvertizeDefault();
      }
    },
    async onPage(advertize) {
      this.lazyParams = advertize;
      this.page_no = advertize.page + 1;
      this.limit = advertize.rows;
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        count: true,
        name: this.advertize_name,
        //   from_date: this.dateFormatYMD(this.advertize_from_date),
        //   to_date: this.dateFormatYMD(this.advertize_to_date),
        status:
          this.advertize_status == null ? "" : this.advertize_status.value,
        type: this.advertize_type == null ? "" : this.advertize_type.value,
      };
      this.loading = true;
      var promise = apis.advertizeList(data);
      promise.then((response) => {
        this.loading = false;
        this.totalRecords = response.data.data;
      });
    },
    get_list: function () {
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        name: this.advertize_name,
        status:
          this.advertize_status == null ? "" : this.advertize_status.value,
        type: this.advertize_type == null ? "" : this.advertize_type.value,
      };
      this.loading = true;
      var promise = apis.advertizeList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.selectstatus = null;
      this.selecttype = null;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "-" + month + "-" + year;
          }
        }
      } else {
        return "";
      }
    },
    async add_update_advertize() {
      this.submitted = true;
      if (!this.product.name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter advertise Name",
          life: 3000,
        });
        return false;
      }
      if (!this.selectstatus) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }
      if (!this.selecttype) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Type",
          life: 3000,
        });
        return false;
      }
      if (!this.product.url) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter URL",
          life: 3000,
        });
        return false;
      }
      if (!this.product.short_description) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter advertise Short Description",
          life: 3000,
        });
        return false;
      }
      if (!this.product.description) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter advertise Description",
          life: 3000,
        });
        return false;
      }
      this.product.status = this.selectstatus.value;
      this.product.type = this.selecttype.value;
      //edit
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          name: this.product.name,
          description: this.product.description,
          short_description: this.product.short_description,
          type: this.product.type,
          url: this.product.url,
          status: this.product.status,
          updated_by: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promise = apis.editadvertize(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        var data1 = {
          name: this.product.name,
          description: this.product.description,
          short_description: this.product.short_description,
          type: this.product.type,
          url: this.product.url,
          status: this.product.status,
          created_by: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promises = apis.addadvertize(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal(response.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteadvertize() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          updated_by: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promise = apis.deleteadvertize(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Role");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";
.icons-list {
  i {
    color: var(--text-color-secondary);
  }
}
</style>
  